import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";

const validationSchema = Yup.object({
    robots: Yup.string().trim().required("Please enter robots.txt content"),
    llms: Yup.string().trim().required("Please enter llms.txt content"),
});

const SeoSetting = () => {
    const [loadingRobots, setLoadingRobots] = useState(false);
    const [fetchingRobots, setFetchingRobots] = useState(true);

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setValues,
    } = useFormik({
        initialValues: {
            robots: "",
            llms: "",
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            setLoadingRobots(true);
            try {
                const res = await axiosInstance.post("/seo/createseo", {
                    robots: formValues.robots,
                    llms: formValues.llms,
                });
                toast.success(res.data?.message || "robots.txt & llms.txt generated successfully");
            } catch (err) {
                toast.error(err?.response?.data?.message || "Failed to generate robots.txt / llms.txt");
            } finally {
                setLoadingRobots(false);
            }
        },
    });

    useEffect(() => {
        const fetchRobots = async () => {
            setFetchingRobots(true);
            try {
                const res = await axiosInstance.get("/seo/getseo");
                const existingRobots =
                    res.data?.data?.robots || res.data?.robots || "";
                const existingLlms =
                    res.data?.data?.llms || res.data?.llms || "";
                setValues((prev) => ({
                    ...prev,
                    robots: existingRobots,
                    llms: existingLlms,
                }));
            } catch (err) {
                console.error("Failed to load existing SEO content:", err);
            } finally {
                setFetchingRobots(false);
            }
        };
        fetchRobots();
    }, []);

    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Seo Setting", path: "*" },
    ];

    return (
        <div className="content-wrapper">
            <div className="page-header">
                <h3 className="page-title">Seo Setting</h3>
                <Breadcrumb items={breadcrumbdata} />
            </div>

            <div className="row g-4">
                <div className="col-md-12">
                    <div className="card shadow-sm">
                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h3 className="mb-0">Generate Robot.txt & Llms.txt</h3>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loadingRobots || fetchingRobots}
                                    >
                                        {loadingRobots ? "Generating..." : "Generate"}
                                    </button>
                                </div>
                                <hr />
                                {fetchingRobots ? (
                                    <div className="text-muted">Loading existing content...</div>
                                ) : (
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <div className="form-group mb-0">
                                                <label htmlFor="robot-content" className="col-form-label">
                                                    Robots.txt
                                                </label>
                                                <textarea
                                                    id="robot-content"
                                                    className="form-control border"
                                                    name="robots"
                                                    placeholder="Enter robots.txt content"
                                                    value={values.robots || ""}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    rows={10}
                                                    style={{ resize: "vertical" }}
                                                />
                                                {touched.robots && errors.robots && (
                                                    <small className="text-danger d-block mt-1">
                                                        {errors.robots}
                                                    </small>
                                                )}
                                            </div>
                                        </div>

                                        {/* Llms.txt field */}
                                        <div className="col-md-6">
                                            <div className="form-group mb-0">
                                                <label htmlFor="llms-content" className="col-form-label">
                                                    Llms.txt
                                                </label>
                                                <textarea
                                                    id="llms-content"
                                                    className="form-control border"
                                                    name="llms"
                                                    placeholder="Enter llms.txt content"
                                                    value={values.llms || ""}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    rows={10}
                                                    style={{ resize: "vertical" }}
                                                />
                                                {touched.llms && errors.llms && (
                                                    <small className="text-danger d-block mt-1">
                                                        {errors.llms}
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeoSetting
